import { defineHttpResources } from '@whop/containers';

export const httpResources = defineHttpResources({
  // @review: is it correct place?
  initialData: { url: `/api/utils/initial-data/` },

  //actions
  changeLanguage: { url: `/api/utils/language/change/`, method: 'POST' },
});
